import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import StatisticLineGraph from '@/components/charts/statistic-line-graph/statistic-line-graph';
import { sessionService } from '@/providers/services/auth/session';
declare var google: any;

@Component({
    name: 'roster-sync-page',
    components: {
        'statistic-page': StatisticLineGraph,
    },
})

export default class RosterSyncPage extends Vue {


    // ---------------------------------------------------------------------
    // Properties

    private rosterSyncs = [
        {
            name: 'Organizations',
            count: 0,
            percentage: '0%',
            key: 'orgs',
            coordinate: [],
            router: '/users-rosters/orgs',
        },
        {
            name: 'Schools',
            count: 0,
            percentage: '0%',
            key: 'schools',
            coordinate: [],
            router: '/users-rosters/schools',
        },
        {
            name: 'Users',
            count: 0,
            percentage: '0%',
            key: 'users',
            coordinate: [],
            router: '/users-rosters/users',
        },
        {
            name: 'Classes',
            count: 0,
            percentage: '0%',
            key: 'classes',
            coordinate: [],
            router: '/users-rosters/classes',
        },
    ];

    private countriesList: any = [];

    private uploadsList: any = [];

    private overallStats: any = {};

    private created() {
        this.fetchOverallStats();
    }

    // --------------------------------------------------------------------
    // Actions

    private onUploadFiles() {
        this.$router.push('/users-rosters/roster-uploads');
    }

    private showRosterList() {
        this.$router.push('/users-rosters/roster-uploads-list');
    }

    private fetchOverallStats() {
        const rosterSyncs = this.rosterSyncs;
        const rosterParams = {
            offset: 0,
            limit: 5,
        };
        axios.all([
            rosterAPI.fetchCountriesList(),
            rosterAPI.fetchOverallRosterStats(),
            rosterAPI.fetchRosterUploads(rosterParams),
        ]).then(axios.spread((countries, overallstats, uploadsListData) => {
            this.uploadsList = uploadsListData.uploadList;
            this.overallStats = overallstats;
            this.parseCountryData(countries);
            rosterSyncs.forEach((sync) => {
                const levelStats = overallstats[sync.key];
                if (levelStats) {
                    sync.count = levelStats.totalCount;
                    sync.coordinate = levelStats.coordinate;
                }
            });
            this.dataDraw();
        }));
    }

    private parseCountryData(countries: any) {
        this.countriesList = [];
        countries.forEach((country: any) => {
            const rowData = [
                country.code,
                country.usersCount,
            ];
            this.countriesList.push(rowData);
        });
    }

    private dataDraw() {
        const component = this;
        google.charts.load('current', {
            packages: ['geochart'],
        });
        google.charts.setOnLoadCallback(drawRegionsMap);

        function drawRegionsMap() {
            const data = google.visualization.arrayToDataTable([
                ['Country', 'Users'],
                ...component.countriesList,

            ]);

            const options = {
                datalessRegionColor: '#4d4d4d',
                defaultColor: '#4d4d4d',
                height: 300,
                width: 600,
                legend: 'none',
                colorAxis: {
                    colors: ['#56a847'],
                },
                tooltip: { trigger: 'none' },
                // displayMode: 'markers',
                // resolution: 'provinces',
            };

            const chart = new google.visualization.GeoChart(document.getElementById('chart_div'));

            chart.draw(data, options);
        }

    }
}
